module.exports = __webpack_public_path__ + "media/o-christmas-tree_dylan-sitts.ba6bcff6.mp3";